<!-- Modals -->
<app-deprecated-modal-form
    #createModal
    [form]="createForm"
    (save)="onCreate(createForm.record, createForm)"
    headerText="employees.records.addRecord"
>
    <app-form-record #createForm></app-form-record>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editModal
    [form]="editForm"
    (save)="onCreate(editForm.record)"
    headerText="employees.records.editRecord"
>
    <app-form-record #editForm></app-form-record>
</app-deprecated-modal-form>

<app-deprecated-modal #viewModal>
    <div class="text-align-left" *ngIf="selectedRecord">
        <h1 class="ui header">{{ selectedRecord?.title }}</h1>
        <div [innerHTML]="selectedRecord.body | sanitizeHtml"></div>
        <h4>{{ selectedRecord?.createdAt | appDate: 'mediumDate' }}</h4>
    </div>
</app-deprecated-modal>

<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    description="employees.records.doYouWantToDeleteThisRecordFromThisEmployee"
    label="employees.records.delete"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event">
        <div class="buttons">
            <ui-button type="primary" (click)="createModal.show()" *permission="createNotePermission; all: true">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'employees.records.createRecord' | translate }}
            </ui-button>
        </div>
    </app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>
        <div class="content">
            <app-table
                [table]="table"
                class="table"
                (menuItemSelected)="menuAction($event)"
                (rowClicked)="onSelect($event); viewModal.show()"
            >
                <app-empty-state
                    [label]="!table.hasFiltersApplied() ? ('employees.records.noRecordsToDisplay' | translate) : ''"
                    src="/assets/illustrations/empty-box.png"
                ></app-empty-state>
            </app-table>
        </div>
    </div>
</div>
